<template>
  <ContainerHub class="hub-sidebar">
    <template slot="header">
      <HubHeader
        :category="name"
        :titleTag="'h2'"
        :title="content.title"
      />
    </template>
    <template slot="body">
      <component v-for="(item, index) in content.items" :is="componentName" display="small" :content="item" :key="`${componentName}-${index}`" />
    </template>
    <template slot="footer">
      <BaseButton
        icon="arrow-right"
        icon-position="right"
        :color="name"
        :route="$t(`message.sidebar.${name}.button.route`)">
          {{ $t(`message.sidebar.${name}.button.text`) }}
      </BaseButton>
    </template>
  </ContainerHub>
</template>

<script>
import BaseButton from '@base/BaseButton'
import ContainerHub from '@containers/ContainerHub'
import CardDocument from '@cards/document/CardDocument'
import CardEvent from '@cards/event/CardEvent'
import CardHoliday from '@cards/holiday/CardHoliday'
import CardTravel from '@cards/travel/CardTravel'
import CardRemoteWorking from '@cards/remote-working/CardRemoteWorking'
import CardWorkgroup from '@cards/workgroup/CardWorkgroup'
import HubHeader from './HubHeader'

export default {
  name: 'HubSidebar',
  props: {
    name: {
      type: String,
      required: true
    },
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    componentName () {
      return this.name === 'documents' ? 'CardDocument'
        : this.name === 'events' ? 'CardEvent'
          : this.name === 'holidays' ? 'CardHoliday'
            : this.name === 'travels' ? 'CardTravel'
              : this.name === 'remoteWorking' ? 'CardRemoteWorking'
                : this.name === 'workgroups' ? 'CardWorkgroup'
                  : 'div'
    }
  },
  components: {
    HubHeader,
    ContainerHub,
    BaseButton,
    CardDocument,
    CardEvent,
    CardHoliday,
    CardTravel,
    CardRemoteWorking,
    CardWorkgroup
  }
}
</script>

<style lang="scss">
  .hub-sidebar{
    .hub-header__title{
      margin: 0;
      h2{
        font-size: 2.4rem;

        &.title--stewardship {
          font-size: 2.1rem;
        }
      }
    }
    .button{
      font-size: 1.3rem;
    }
  }
</style>
